export default __webpack_public_path__ + "static/media/oob-full-macos.536fe91a.avif";